import {Component, Input} from '@angular/core';

export type CarouselItem = {
  imageUrl: string;
  alt?: string;
  title?: string;
  text?: string;
};


@Component({
  selector: 'app-carouselorini',
  standalone: false,
  templateUrl: './carouselorini.html',
  styleUrl: './carouselorini.css'
})
export class Carouselorini {
  @Input() carouselId = 'app_carousel_' + Math.random().toString(36).slice(2, 8);
  @Input() heading?: string;
  @Input({ required: true }) items: CarouselItem[] = [];
  @Input() autoCycle = true;
  @Input() interval = 8000;
  @Input() showIndicators = true;
  @Input() showControls = true;
  @Input() slidesPerView = 3;

  get slidesCount(): number {
    const n = this.items?.length ?? 0;
    return n ? Math.ceil(n / Math.max(this.slidesPerView, 1)) : 0;
  }

  /** [0,1,2,...slidesCount-1] for indicators and outer slides */
  get slideIndexes(): number[] {
    return Array.from({ length: this.slidesCount }, (_, i) => i);
  }

  /** slice helper for inner cards */
  sliceFor(i: number) {
    const start = i * this.slidesPerView;
    const end = Math.min((i + 1) * this.slidesPerView, this.items.length);
    return this.items.slice(start, end);
  }
}
